export * from "./dashboard-table.component";
